var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('AuctionCategoryHeader'),_c('v-row',_vm._l((_vm.auctionsType),function(item){return _c('v-col',{key:item.id,attrs:{"cols":"12","md":"6"}},[_c('CardAuctionsType',{attrs:{"item":item}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }